import {
  Component,
  computed,
  inject,
  input,
  output,
  ViewChild,
} from '@angular/core';
import { BasketService, SinglePlanPromoPriceComponent } from '@basket';
import { CatalogueService } from '@catalogue';
import { CardComponent } from '@components';
import { CONFIG } from '@config';
import { CustomerService } from '@customer';
import { CurrencyFormatPipe } from '@i18n';
import { BasketApplianceComponent } from '../basket-appliance/basket-appliance.component';

@Component({
  selector: 'app-basket',
  imports: [
    BasketApplianceComponent,
    CardComponent,
    CurrencyFormatPipe,
    SinglePlanPromoPriceComponent,
  ],
  templateUrl: './basket.component.html',
  styleUrl: './basket.component.scss',
})
export class BasketComponent {
  private readonly basketService = inject(BasketService);
  private readonly catalogueService = inject(CatalogueService);
  private readonly config = inject(CONFIG);
  private readonly customerService = inject(CustomerService);

  readonly toggled = output<boolean>();
  readonly startCollapsed = input(true);

  @ViewChild(CardComponent) card!: CardComponent;

  readonly clientName = this.config.clientName;
  readonly customerSelectedToPurchasePlan =
    this.customerService.customerSelectedToPurchasePlan;
  readonly hasDiscountedMonths = this.basketService.basketItemQuoteHasPromo;
  readonly numberOfDiscountedMonths =
    this.basketService.basketItemQuoteFreeMonths;
  readonly quoteMonthlyPayment =
    this.basketService.basketItemQuoteDetailsPaymentOption;
  readonly steppedFormAppliance = this.catalogueService.steppedFormAppliance;

  readonly total = computed(() =>
    this.basketService.basket()
      ? this.basketService
          .basketItemQuoteDetailsPaymentOption()
          .subsequentPayment.toFixed(2)
      : null,
  );

  forceCollapse(): void {
    this.card.forceCollapse();
  }
}
